<template>
  <b-modal id="generateDocumentForOrderModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.exsborder.generateDocumentForOrderModalHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <EXSBDocumentCreate :order="order"></EXSBDocumentCreate>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="float-right">
          <b-button v-if="$store.state.userdata.update.updated" class="btn btn-secondary" @click="closeModal()">{{ $t('buttons.close') }}</b-button>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXSBDocumentCreate from '../../../exsbdocument/Create'
export default {
  name: 'GenerateDocumentForOrderModal',
  components: {
    EXSBDocumentCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.exsborder.generateDocument.show
    },
    orderObject () {
      return this.$store.state.modals.exsborder.generateDocument.order
    },
    close () {
      return this.$store.state.modals.exsborder.generateDocument.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'orderObject': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      order: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.orderObject) {
        this.order = Object.assign({}, this.orderObject)
        this.$store.state.modals.exsborder.generateDocument.show = 0
        this.$store.state.modals.exsborder.generateDocument.order = null
        this.$bvModal.show('generateDocumentForOrderModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.exsborder.generateDocument.close = 0
      }
      this.$bvModal.hide('generateDocumentForOrderModal')
    },
    resetData () {
      // console.log()
    }
  }
}
</script>

<style scoped>

</style>
